// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoSection-module--root--1U-8A","cards":"InfoSection-module--cards--1Vjtb"};